import React from "react";
import { Col, Form, InputGroup } from "react-bootstrap";
import ErrorLabel from "../ErrorLabel/ErrorLabel";

const AutoCompleteInput = ({
  CityList,
  EditFlag,
  EditCity,
  ApiCity,
  onCityFuc,
  ErrDisplay,
  NameFlag,
  Md,
  className,
}) => {
  return (
    <Col md={Md} className={className ? className : ""}>
      <Form.Group className="mb-0" controlId="formBasicEmail">
        <Form.Label className="form-label-custom">
          City <span className="star-required">*</span>
        </Form.Label>
        <InputGroup className="edit-border">
          <Form.Control
            list="browsers"
            id="myBrowser"
            name={NameFlag}
            onChange={(e) => onCityFuc(e, true)}
            placeholder="Enter City Name"
            value={EditFlag === true ? EditCity : ApiCity}
            maxLength={60}
            autoComplete="off"
          />
          <datalist id="browsers">
            {CityList?.length > 0 ? (
              CityList?.map((data) => {
                return <option value={data.city_name}></option>;
              })
            ) : (
              <></>
            )}
          </datalist>
        </InputGroup>
      </Form.Group>
      <ErrorLabel ErrorDisplay={ErrDisplay} />
    </Col>
  );
};

export default AutoCompleteInput;
